/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { Fragment, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect, generatePath } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { differenceInSeconds, subSeconds } from 'date-fns';
import useElementsVisibility from 'app/hooks/useElementsVisibility';
import useConfig from 'app/hooks/useConfig';
import useUtils from 'app/hooks/useUtils';
import { ModalTypical, Modal, Button } from 'app/components';
import Breadcrumbs from '../components/Breadcrumbs';
import StepTickets from '../StepTickets';
import StepSeats from '../StepSeats';
import StepCheckout from '../StepCheckout';
import useSessionEffect from '../hooks/useSessionEffect';
import useStepRefreshRestriction from '../hooks/useStepRefreshRestriction';
import useFromPaymentRestriction from '../hooks/useFromPaymentRestriction';
import useBackBrowserOnWizardRules from '../hooks/useBackBrowserOnWizardRules';
import useSaveRoute from '../hooks/useSaveRoute';
import StepSnacksAndDrinks from '../StepSnacksAndDrinks';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import search from 'app/store/search';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  setLoaderData: PropTypes.func.isRequired,

  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
    params: PropTypes.shape({
      movieCinemaId: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,

  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    state: PropTypes.shape({
      route: PropTypes.string.isRequired
    })
  }).isRequired,

  error: PropTypes.shape({
    code: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    expectedErrors: PropTypes.object.isRequired
  }),

  sessionIsLoaded: PropTypes.bool.isRequired,
  isOrdered: PropTypes.bool.isRequired,
  isPaymentStatus: PropTypes.bool.isRequired,

  orderId: PropTypes.string,
  userSessionId: PropTypes.string,
  previousRoute: PropTypes.string,
  showtime: PropTypes.string,
  redSessionTTL: PropTypes.number,
  orderTTL: PropTypes.number,
  timeToNotification: PropTypes.number,

  cancelOrder: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired,
  notify: PropTypes.func.isRequired,
  saveOrderId: PropTypes.func.isRequired,
  wizardClear: PropTypes.func.isRequired,
  clearPaymentStatus: PropTypes.func.isRequired,
  giftCardpayment: PropTypes.bool.isRequired,
  clearOrder: PropTypes.func.isRequired,
};

const defaultProps = {
  redSessionTTL: null,
  orderTTL: null,
  showtime: null,
  timeToNotification: 61,
  orderId: null,
  error: null,
  previousRoute: null,
  // userSessionId: null
};

const isRedSessionLimited = (time, redSessionTTL, timeToNotification, getDateWithOffset) => {
  const now = getDateWithOffset();
  const redSessionTime = subSeconds(getDateWithOffset(time), redSessionTTL);
  const diff = differenceInSeconds(redSessionTime, now);

  return diff < timeToNotification;
};

const Wizard = ({
  history: { push },
  match: {
    url,
    params: { movieCinemaId }
  },
  location: { pathname, state },

  error,
  sessionIsLoaded,
  isOrdered,

  redSessionTTL,
  orderTTL,
  showtime,
  timeToNotification,
  orderId,
  previousRoute,
  userSessionId,
  isPaymentStatus,

  cancelOrder,
  clearError,
  notify,
  saveOrderId,
  wizardClear,
  clearPaymentStatus,
  giftCardpayment,
  setLoaderData,
  clearOrder
}) => {
  const [t] = useTranslation();
  const [newAboId, setNewAboId] = useState([]);
  const { routes } = useConfig();
  const { getDateWithOffset } = useUtils();
  const location = useLocation();
  const email = location?.state?.email;
  const promotionId = location?.state?.promotionId;
  const cinemaId = location?.state?.cinemaId;
  // const labels = email ? ['seats', 'checkout', 'pay'] : ['tickets', 'seats', 'checkout', 'pay'];
  const toTimerTime = time => time * 1000;
  // const BREADCRUMBS = labels.map(label => t(`purchase.${label}`));
  const cinemas = useSelector(state => state?.cinemas?.cinemas);
  const labelsData = cinemas?.filter((item) => {
    const cinemaId = pathname?.split("/")[3]?.split('-')[0];
    return item?.id === cinemaId;
  })
  const country = process.env.REACT_APP_COUNTRY;
  const labelsData2 = email ? ['seats', 'checkout', 'pay'] : (country === 'aut' && labelsData[0]?.concessionsale) ? ['tickets', 'seats', 'snacks', 'checkout', 'pay'] : ['tickets', 'seats', 'checkout', 'pay'];

  const BREADCRUMBS = labelsData2.map(label => t(`purchase.${label}`));
  const activeStep = labelsData2.indexOf(pathname.split('/').reverse()[0]);
  const {
    restriction: [isRestrictionModal, yes, no],
    fail: [isFailModal, retry, back]
  } = useFromPaymentRestriction(movieCinemaId);
  const [modal, setModal] = useState({
    isVisible: false,
    onClose: () => { },
    title: null,
    message: null
  });

  const orderModalSettings = useMemo(
    () => ({
      isVisible: true,
      title: t('purchase.modals.timer_order.header'),
      message: t('purchase.modals.timer_order.message'),
      onClose: () => {
        setModal({ isVisible: false });
        // push(generatePath(routes.stepTickets.pattern, { movieCinemaId }));
        if (email && previousRoute === null) {
          push(`/tickets/${cinemaId}/abo/${promotionId}/select?email=${email}`);
          clearOrder();
        }
        else {
          push(generatePath(routes.stepTickets.pattern, { movieCinemaId }));
        }
      }
    }),
    // eslint-disable-next-line
    []
  );

  const sessionModalSettings = useMemo(
    () => ({
      isVisible: true,
      title: t('purchase.modals.timer_session.header'),
      message: t('purchase.modals.timer_session.message'),
      onClose: () => {
        if (email && previousRoute === null) {
          setModal({ isVisible: false });
          push(`/tickets/${cinemaId}/abo/${promotionId}/select?email=${email}`);
          clearOrder();
        }
        else {
          push(previousRoute);
        }
      }
    }),
    // eslint-disable-next-line
    [previousRoute]
  );
  useEffect(() => {
    setNewAboId([state?.isAboId, state?.aboId, state?.operaSessionsData]);
  }, [])

  // noindex tag 
  useEffect(() => {
    const metaTag = document.createElement('meta');
    metaTag.name = "robots";
    metaTag.content = "noindex";


    document.head.appendChild(metaTag);

    return () => {
      document.head.removeChild(metaTag);
    };
  }, []);

  const errorModalSetting = useMemo(
    () =>
      error && {
        isVisible: true,
        title: t('purchase.modals.timer_session.header'),
        message: error.message || t('purchase.modals.timer_session.message'),
        onClose: () => {
          push(previousRoute);
        }
      },
    // eslint-disable-next-line
    [error, previousRoute]
  );

  useElementsVisibility({ header: false, footer: false });
  useSessionEffect(movieCinemaId);
  useStepRefreshRestriction(activeStep, movieCinemaId);
  useBackBrowserOnWizardRules(activeStep, movieCinemaId);
  useSaveRoute();

  useEffect(() => {
    return () => {
      clearError();
      wizardClear();
      clearPaymentStatus();
    };
  }, [clearError, wizardClear, clearPaymentStatus]);

  /**
   * Manages creation and canceling of an order
   */
  useEffect(() => {
    if (!email && userSessionId && activeStep === 0) {
      // cancelOrder(userSessionId);
    }

    if (orderId && orderId === userSessionId && activeStep === 0) {
      // cancelOrder(orderId);
      setLoaderData(true)
      const timer = setTimeout(() => {
        if (userSessionId) {
          // saveOrderId(userSessionId);
        }
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [activeStep, orderId, email, userSessionId]);

  /**
   * Red Session Restriction Check for first and second steps
   */
  useEffect(() => {
    if (!isPaymentStatus && showtime && redSessionTTL) {
      if (
        (activeStep === 0 || activeStep === 1) &&
        isRedSessionLimited(showtime, redSessionTTL, timeToNotification, getDateWithOffset)
      ) {
        setModal(sessionModalSettings);
      }
    }
  }, [
    activeStep,
    showtime,
    redSessionTTL,
    isPaymentStatus,
    getDateWithOffset,
    sessionModalSettings,
    timeToNotification
  ]);

  /**
   * Handles api errors while payment / reservation or selection plan
   */
  useEffect(() => {
    if (error) {
      const { type, code, expectedErrors } = error;

      if (
        expectedErrors &&
        Object.values(expectedErrors).find(err => err.type === type && err.code === code)
      ) {
        setModal(errorModalSetting);
      }
    }
  }, [error,
    errorModalSetting
  ]);

  /**
   * Starts an order timer
   */
  useEffect(() => {
    if (
      isPaymentStatus ||
      !(orderTTL && isOrdered) ||
      isRedSessionLimited(showtime, redSessionTTL, orderTTL, getDateWithOffset)
    ) {
      return undefined;
    }

    const delay = orderTTL;
    const delayNotification = orderTTL - timeToNotification;

    const timer = setTimeout(() => {
      setModal(orderModalSettings);
    }, toTimerTime(delay));

    const timerNotification = setTimeout(() => {
      notify('warning', 'purchase.toasters.order_timer');
    }, toTimerTime(delayNotification));

    return () => {
      clearTimeout(timer);
      clearTimeout(timerNotification);
    };
  }, [
    orderTTL,
    isOrdered,
    isPaymentStatus,
    getDateWithOffset,
    notify,
    orderModalSettings,
    redSessionTTL,
    showtime,
    timeToNotification
  ]);

  /**
   * Starts a red session timer
   */
  useEffect(() => {
    if (isPaymentStatus || !(showtime && redSessionTTL && isOrdered)) {
      return undefined;
    }

    const now = getDateWithOffset();
    const time = subSeconds(getDateWithOffset(showtime), redSessionTTL);
    const delay = differenceInSeconds(time, now);
    const delayNotification = delay - timeToNotification;

    const timeOut = () => {
      const sevenDaysOnMilliseconds = 604800000;
      const twentyFourDaysOnMilliseconds = 2073600000;

      if (toTimerTime(delay) > twentyFourDaysOnMilliseconds) {
        return sevenDaysOnMilliseconds;
      }

      return toTimerTime(delay);
    };

    const timeOutNotification = () => {
      const sevenDaysOnMilliseconds = 604800000;
      const twentyFourDaysOnMilliseconds = 2073600000;

      if (toTimerTime(delayNotification) > twentyFourDaysOnMilliseconds) {
        return sevenDaysOnMilliseconds - timeToNotification;
      }

      return toTimerTime(delayNotification);
    };

    const timer = setTimeout(() => {
      setModal(sessionModalSettings);
    }, timeOut());

    const timerNotification = setTimeout(() => {
      notify('warning', 'purchase.toasters.session_timer');
    }, timeOutNotification());

    return () => {
      clearTimeout(timer);
      clearTimeout(timerNotification);
    };
  }, [
    showtime,
    redSessionTTL,
    isOrdered,
    isPaymentStatus,
    getDateWithOffset,
    notify,
    sessionModalSettings,
    timeToNotification
  ]);


  return sessionIsLoaded ? (
    <Fragment>
      <Breadcrumbs active={activeStep} items={BREADCRUMBS} />

      <Switch>
        <Route
          path={generatePath(routes.stepTickets.pattern, { movieCinemaId })}
          render={props =>
            !isPaymentStatus && <StepTickets {...props} movieCinemaId={movieCinemaId} isAboId={newAboId[0]} aboId={newAboId[1]} operaSessionsData={newAboId[2]} />
          }
        />
        <Route
          path={generatePath(routes.stepSeats.pattern, { movieCinemaId })}
          render={props =>
            !isPaymentStatus && <StepSeats {...props} movieCinemaId={movieCinemaId} />
          }
        />
        <Route
          path={generatePath(routes.stepSnacksAndDrinks.pattern, { movieCinemaId })}
          render={props =>
            !isPaymentStatus && <StepSnacksAndDrinks {...props} movieCinemaId={movieCinemaId} />
          }
        />
        <Route
          path={generatePath(routes.stepCheckout.pattern, { movieCinemaId })}
          // render={props =>
          //   !isPaymentStatus && <StepCheckout {...props} movieCinemaId={movieCinemaId} />
          // }
          component={StepCheckout}
        />

        <Redirect from={url} to={generatePath(routes.stepTickets.pattern, { movieCinemaId })} />
      </Switch>

      <Modal isSmall isOpen={modal.isVisible} close={modal.onClose} title={modal.title}>
        <ModalTypical
          withIcon={false}
          message={modal.message}
          btnText={t('common.ok')}
          click={modal.onClose}
        />
      </Modal>

      <Modal
        isSmall
        isOpen={isRestrictionModal}
        close={no}
        title={t('purchase.modals.payment_checkout.header')}
      >
        <ModalTypical
          withIcon={false}
          title={t('purchase.modals.payment_checkout.title')}
          message={t('purchase.modals.payment_checkout.message')}
        >
          <ModalTypical.ButtonsRow>
            <Button isDefault onClick={no}>
              {t('common.no')}
            </Button>
            <Button isPrimary onClick={yes}>
              {t('common.yes')}
            </Button>
          </ModalTypical.ButtonsRow>
        </ModalTypical>
      </Modal>

      <Modal
        isSmall
        isOpen={isFailModal}
        close={retry}
        title={t('purchase.modals.payment_status_fail.header')}
      >
        <ModalTypical withIcon={false} message={t('purchase.modals.payment_status_fail.message')}>
          <ModalTypical.ButtonsRow>
            <Button isDefault onClick={back}>
              {t('common.back')}
            </Button>
            <Button isPrimary onClick={retry}>
              {t('common.recheck')}
            </Button>
          </ModalTypical.ButtonsRow>
        </ModalTypical>
      </Modal>
    </Fragment>
  ) : null;
};

Wizard.defaultProps = defaultProps;
Wizard.propTypes = propTypes;
export default Wizard;
